const VisPagePostLogout = () => import('@/views/vis-page-post-logout');

export default [
  {
    path: "/signout",
    name: "postLogout",
    component: VisPagePostLogout,
    props: route => ({ state: route.query.state })
  }
]
